exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-loading[data-v-6ae436b8]{margin:auto}", ""]);

// exports
